import React, { ReactNode, useCallback, useState } from 'react'
import { useModuleConfig } from '../../hooks/useModuleConfig'
import { MODULE_KEYS, TRUST_SIGNALS_DEFAULTS } from '../../moduleRegistry'
import { BBBBadge } from './BBBBadge'
import { TrustpilotBadge } from './TrustpilotBadge'
import { SmartAssetBadge } from './SmartAssetBadge'
import { TrustSignalsRotator } from './MobileRotator'
import '../../styles/TrustSignalsModule/TrustSignalsModule.scss'

export const TrustSignalsModule = () => {
  const { bbb, trustpilot, smartasset } = useModuleConfig(MODULE_KEYS.trustSignals, TRUST_SIGNALS_DEFAULTS)

  // A third-party badge proves it can render only once its script runs, so it stays
  // staged until it confirms and is dropped when it cannot.
  const [trustpilotLoad, setTrustpilotLoad] = useState<'pending' | 'loaded' | 'failed'>('pending')
  const onTrustpilotResult = useCallback((loaded: boolean) => {
    setTrustpilotLoad(loaded ? 'loaded' : 'failed')
  }, [])

  const badges: Array<{ key: string, node: ReactNode, staged?: boolean }> = []
  if (bbb) badges.push({ key: 'bbb', node: <BBBBadge /> })
  if (trustpilot && trustpilotLoad !== 'failed') {
    badges.push({
      key: 'trustpilot',
      node: <TrustpilotBadge onResult={onTrustpilotResult} />,
      staged: trustpilotLoad === 'pending'
    })
  }
  if (smartasset) badges.push({ key: 'smartasset', node: <SmartAssetBadge /> })

  if (badges.length === 0) return null

  // With every badge still staged the module itself reserves no space.
  const moduleClassName = badges.some(({ staged }) => staged !== true)
    ? 'trust-signals-module'
    : 'trust-signals-module trust-signals-module--staging-only'

  return (
    <div className={moduleClassName}>
      <TrustSignalsRotator badges={badges} />
    </div>
  )
}
